import { lazy, Suspense } from "react";
import { entryRoute } from "./entry-route";
const ProductLanding = lazy(() =>
  import("./ProductLanding").then((m) => ({ default: m.ProductLanding })),
);
const VisionLanding = lazy(() =>
  import("./VisionLanding").then((m) => ({ default: m.VisionLanding })),
);
const AgentWorkspaceExecutor = lazy(() =>
  import("./AgentWorkspaceExecutor").then((m) => ({
    default: m.AgentWorkspaceExecutor,
  })),
);
const AgentRenderer = lazy(() =>
  import("./AgentRenderer").then((m) => ({ default: m.AgentRenderer })),
);
const AgentWorkspacePreview = lazy(() =>
  import("./AgentWorkspacePreview").then((m) => ({
    default: m.AgentWorkspacePreview,
  })),
);
// Simulated concept of concurrent agent conversations; no board data is used.
const route = entryRoute(new URL(location.href));
const agentPreview = route === "agent-preview";
const visionPage = route === "vision";
if (visionPage && !/^\/(vision\/?)?$/.test(location.pathname))
  history.replaceState(null, "", `/${location.search}${location.hash}`);
const productPage = route === "product";

import { installTelemetry } from "./telemetry";
import { installDiagnostics } from "./diagnostics";
import { BugReporter, WorkspaceErrorBoundary } from "./BugReporter";
import { createRoot } from "react-dom/client";
import { Entry } from "./CloudIdentity";
import "./style.css";
import "./workspace.css";
import "./workspace-refinements.css";
import "./contextual-tools.css";
import "./header.css";
import "./toolbars-settings.css";
import "./text-table-controls.css";
import "./compact-workspace.css";
import "./workspace-dock.css";
installTelemetry(); // Before diagnostics wraps fetch.
installDiagnostics();
createRoot(document.getElementById("root")!).render(
  <>
    <WorkspaceErrorBoundary>
      {visionPage ? (
        <Suspense fallback={<p>Opening Calque’s vision…</p>}>
          <VisionLanding />
        </Suspense>
      ) : productPage ? (
        <Suspense fallback={<p>Opening Calque’s product…</p>}>
          <ProductLanding />
        </Suspense>
      ) : route === "agent-workspace" ? (
        <Suspense fallback={<p>Preparing tools…</p>}>
          <AgentWorkspaceExecutor />
        </Suspense>
      ) : route === "agent-render" ? (
        <Suspense fallback={<p>Preparing renderer…</p>}>
          <AgentRenderer />
        </Suspense>
      ) : agentPreview ? (
        <Suspense fallback={null}>
          <AgentWorkspacePreview />
        </Suspense>
      ) : (
        <Entry />
      )}
    </WorkspaceErrorBoundary>
    {!agentPreview && !visionPage && !productPage && <BugReporter />}
  </>,
);
